import InputLabel from '@anm/components/form/InputLabel';
import TextInputWrapper from '@anm/components/form/TextInput/Wrapper';
import { media, subscriptionModalSidePaddings } from '@anm/styles/helpers';
import styled from 'styled-components';

const emailFieldRowTablet = media.tablet`
  width: 100%;
`;

export const EditCardFormWrapper = styled.div`
  margin-bottom: 25px;
  ${subscriptionModalSidePaddings};
`;

export const EditCardFormBlock = styled.div`
  ${TextInputWrapper} input {
    margin-bottom: 0;
  }
`;

export const EditCardFormRow = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
`;

export const EditCardFormRowItem = styled.div`
  margin: 10px;
  flex: 1 1 240px;
`;

export const EmailFieldRow = styled.div`
  margin: 10px;
  flex: 0 1 240px;
  display: flex;
  align-items: flex-end;
  width: calc(50% + 105px);
  ${emailFieldRowTablet};
`;

export const EmailFiledWrapper = styled.div`
  flex: 1;
`;

export const EmailFieldExtraDescription = styled.span`
  max-width: 120px;
  display: inline-block;
  color: #a0a0a7;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  vertical-align: middle;
  text-transform: none;
  margin-left: 10px;
`;

export const CardZipCodeFieldWrapper = styled.div`
  ${InputLabel} {
    &:after {
      content: 'US card only';
      color: #a0a0a7;
      text-transform: none;
      margin-left: 5px;
    }
  }
`;
